import { autoinject, transient } from "aurelia-dependency-injection";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { SaveWorkflowConfigurationRequest, SaveWorkflowConfigurationResponse, GetWorkflowConfigurationsResponse, GetEntityTypesForWorkflowResponse, WorkflowAcceptRequest, WorkflowStateUpdatedResponse, CloneWorkflowConfigurationRequest, CloneWorkflowConfigurationResponse } from "../../models/workflow/workflow.models";
import { WorkflowConfigurationUrls } from "../../constants/workflow/workflow-configuration.constants";

@autoinject()
@transient()
export class WorkflowConfigurationService {

    public constructor(private requestClient: RequestClientService) { }

    public getWorkflowConfigurations(entityTypeId: number, branchId: number): Promise<GetWorkflowConfigurationsResponse> {
        return this.requestClient.get(WorkflowConfigurationUrls.getWorkflowConfigurations, { entityTypeId, branchId });
    }

    public getActivityMetadata<T>(entityTypeId: number, pluginInternalName: string, branchId: string): Promise<T> {
        return this.requestClient.get(WorkflowConfigurationUrls.getActivityMetadata, { entityTypeId, pluginInternalName, branchId });
    }

    public getWorkflowConfiguration(workflowConfigurationId: number): Promise<GetWorkflowConfigurationsResponse> {
        return this.requestClient.get(WorkflowConfigurationUrls.getWorkflowConfiguration, { id: workflowConfigurationId });
    }

    public saveWorkflowConfiguration(request: SaveWorkflowConfigurationRequest): Promise<SaveWorkflowConfigurationResponse> {
        return this.requestClient.post(WorkflowConfigurationUrls.saveWorkflowConfiguration, {}, request);
    }

    public cloneWorkflowConfiguration(request: CloneWorkflowConfigurationRequest): Promise<CloneWorkflowConfigurationResponse> {
        return this.requestClient.post(WorkflowConfigurationUrls.cloneWorkflowConfiguration, {}, request);
    }

    public deleteWorkflowConfiguration(workflowConfigurationId: number): Promise<SaveWorkflowConfigurationResponse> {
        return this.requestClient.post(WorkflowConfigurationUrls.deleteWorkflowConfiguration, {}, { workflowConfigurationId: workflowConfigurationId });
    }

    public accept(request: WorkflowAcceptRequest): Promise<WorkflowStateUpdatedResponse> {
        return this.requestClient.post(WorkflowConfigurationUrls.accept, {}, request);
    }

    public getEntityTypesForWorkflow(): Promise<GetEntityTypesForWorkflowResponse> {
        return this.requestClient.get(WorkflowConfigurationUrls.getEntityTypesForWorkflow, {});
    }
}
